<template>
  <div class="tab-panel-card card-bg">
    <!--卡片头部，包括股票名以及代码-->
    <div class="card-row-one">
      <div class="card-name" @click="handleClick">
        <span class="card-stock-name text-primary">{{ handleStockName(item.stock_name) }}</span>
        <span class="card-stock-code text-desc">({{ item.stock_code.slice(2) }})</span>
        <div class="card-right-tip">
          <span class="right-icon-ti text-desc">查看详情</span>
          <img src="../images/icon_list_forwardNew@3x.png"/>
        </div>
      </div>
    </div>
    <!--分割线-->
    <div class="divide-line"></div>
    <!--发行价-->
    <div class="card-two-section-one flex jc-sb ai-c">
      <div class="card-key text-sub">发行价</div>
      <div class="card-value ff-ths text-primary">
        <span>{{ handlePrice(item.issue_price) }}</span>
      </div>
    </div>
    <!--一首中签率-->
    <div class="card-two-section-one flex jc-sb ai-c">
      <div class="card-key text-sub">一手中签率</div>
      <div class="card-value ff-ths text-primary">
        <span>{{ item.success_rate ? item.success_rate + '%' : '--' }}</span>
      </div>
    </div>
    <div class="card-two-section-one flex jc-sb ai-c">
      <div class="card-key text-sub">公布中签</div>
      <div class="card-value ff-ths text-primary">
        <span>{{ item.success_date || '--' }}</span>
      </div>
    </div>
    <!--暗盘交易-->
    <div class="card-two-section-one flex jc-sb ai-c">
      <div class="card-key text-sub">暗盘交易</div>
      <div class="card-value ff-ths text-primary" v-if="item.dark_rise">
        <span class="dark-time-2"
              :class="getNumberColor(item.dark_rise)">{{ item.dark_close_price ? Number(item.dark_close_price).toFixed(2) : '--' }}</span>
        <span class="increase" :class="getNumberColor(item.dark_rise)">{{ handleNumber(item.dark_rise) }}</span>
      </div>
      <template v-else>
        <div class="card-value ff-ths text-primary" v-if="isReachStartTime(`${item.success_date} 16:15`)">
          <span class="dark-time-2"
                :class="getNumberColor(item.changePercent)">{{ item.newPrice || '--' }}</span>
          <span class="increase" :class="getNumberColor(item.changePercent)">{{ handleNumber(item.changePercent) }}</span>
        </div>
        <div class="card-value ff-ths text-primary" v-else>
          <span class="dark-time" v-if="isReachStartTime(item.success_date)">今日<span>16:15</span>开始</span>
          <span class="dark-time-2" v-else>{{ item.success_date + ' 16:15' }}</span>
        </div>
      </template>
    </div>
    <!--todo 暗盘提示后期展示-->
    <!--<div class="dark-tip-box" v-if="item.success_date">-->
    <!--  <div class="tip-icon"></div>-->
    <!--  <div class="dark-tip">港交所下午临时休市，暗盘提前开始</div>-->
    <!--</div>-->
    <!--上市时间-->
    <div class="card-two-section-one flex jc-sb ai-c">
      <div class="card-key text-sub">上市时间</div>
      <div class="card-value ff-ths text-primary">{{ item.listing_date }}</div>
    </div>
    <!--分割线-->
    <div class="divide-line" v-if="isReachStartTime(item.success_date)"></div>
    <!--卡片底部申购按钮-->
    <div class="card-bottom" v-if="isReachStartTime(item.success_date)">
      <div class="card-bottom-btn global-bg text-sub" @click="toSaleResult">配售结果</div>
      <div v-if="false" class="card-bottom-btn global-bg text-sub ifind-buy-button" @click="toSuccessResult">查询中签</div>
      <div class="card-bottom-btn global-bg text-sub" @click="toFenShi">暗盘行情</div>
    </div>
  </div>
</template>

<script>
import {handleStockName} from "@/pages/indexPage/pages/hkStock/common/utils";

export default {
  name: "ToBeListedCard",
  props: {
    item: {
      type: Object,
      required: true
    },
    hideBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //最新价
      newPrice: '',
      //涨跌幅
      change: '',
    };
  },
  methods: {
    /**
     * 处理价格
     */
    handlePrice(price) {
      if (price) {
        const num = Number(price);
        if (num) return num.toFixed(3)
        else return '--'
      }
      return '--'
    },

    /**
     * 处理股票名称
     */
    handleStockName(name) {
      return handleStockName(name);
    },

    /**
     * 判断正负0
     */
    handleNumber(str) {
      //num存在值
      if (str) {
        const num = parseFloat(str);
        if (num > 0) {
          return `+${Number(num).toFixed(2)}%`;
        } else if (num < 0) {
          return `${Number(num).toFixed(2)}%`;
        } else if (Number(num) === 0) {
          return '0.00%';
        }
      }
      return '--';
    },

    /**
     * 根据数字（百分数或小数）字符串获取css
     * @param str 百分数或小数字符串
     */
    getNumberColor(str) {
      const num = parseFloat(str);
      if (num > 0) {
        return 'text-red';
      } else if (num < 0) {
        return 'text-green';
      } else {
        return 'text-black';
      }
    },

    /** 判断是否到开始时间时间 */
    isReachStartTime(timeStr) {
      const curTime = Date.now();
      //开始时间,解决ios不能解析带有-的时间字符串
      const startTime = new Date(timeStr.replace(/-/g, '/')).getTime();
      return curTime > startTime;
    },

    handleClick() {
      this.$emit('click')
    },

    toSaleResult() {
      // 调用F10跳转页面方法 打开新页面跳转
      window.F10Utils.jumpToLink({
        url: `${window.result_api}?stockCode=${this.item.stock_code}&stockName=${this.item.stock_name}`
      });
    },

    toSuccessResult() {
      this.$emit('success')
    },

    toFenShi() {
      window.location.href = 'client.html?action=ymtz^webid=2205^stockcode=' + this.item.stock_code + '^marketid=' + this.item.stock_market;
    }
  }
};
</script>

<style scoped lang="less">
@import "../style/mixins";

.tab-panel-card {
  &:last-child {
    margin-bottom: 0rem;
  }

  padding: 0.32rem;
  border-radius: 0.16rem;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .card-row-one {
    .card-name {
      display: flex;
      flex-direction: row;
      align-items: center;

      .card-stock-name {
        font-family: PingFangSC-Medium;
        font-size: 0.36rem;
        letter-spacing: 0;
        font-weight: 500;
      }

      .card-stock-code {
        margin-left: 0.08rem;
        font-family: PingFangSC-Medium;
        font-size: 0.32rem;
        letter-spacing: 0;
        font-weight: 500;
      }

      .card-right-tip {
        margin-left: auto;
        display: flex;
        flex-direction: row;
        align-items: center;

        .right-icon-tip {
          font-family: PingFangSC-Regular;
          font-size: 0.28rem;
          letter-spacing: 0;
          text-align: right;
          font-weight: 400;
        }

        img {
          width: 0.24rem;
          height: 0.24rem;
        }
      }
    }

    .row-one-calendar {
      font-family: "PingFangSC-Regular";
      color: #4691ee;
      font-size: 0.26rem;
    }
  }

  .divide-line {
    width: 100%;
    height: 0.02rem;
    .theme-mixins(box-shadow, inset 0px -0.01rem 0px 0px rgba(238, 238, 238, 1), inset 0px -0.01rem 0px 0px rgba(46, 46, 46, 1));
    margin-top: 0.28rem;
  }

  .card-two-section-one {
    padding-top: 0.24rem;

    .card-key {
      width: 37.1%;
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      letter-spacing: 0;
      font-weight: 400;
    }

    .card-value {
      width: 62.9%;
      text-align: left;
      font-family: THS;
      font-size: 0.32rem;
      letter-spacing: 0;
      font-weight: 500;

      .dark-time {
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        letter-spacing: 0;
        font-weight: 400;

        span {
          font-family: THS;
          font-size: 0.32rem;
        }
      }

      .dark-time-2 {
        font-family: THS;
        font-size: 0.32rem;
        letter-spacing: 0;
        font-weight: 500;
      }

      .increase {
        margin-left: 0.32rem;
      }
    }
  }

  .dark-tip-box {
    width: 100%;

    .tip-icon {
      width: 0;
      height: 0;
      border-width: 0.12rem;
      border-style: solid;
      border-color: transparent transparent #FEF8E6 transparent;
      margin-left: 0.26rem;
    }

    .dark-tip {
      height: 0.48rem;
      background: #fef8e1;
      border-radius: 0.16rem;
      padding-left: 0.24rem;
      padding-top: 0.12rem;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      color: #FE6E00;
      letter-spacing: 0;
      font-weight: 400;
    }
  }

  .card-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding-top: 0.32rem;
    align-items: center;
    justify-content: space-between;

    .card-bottom-btn {
      width: 1.68rem;
      height: 0.64rem;
      border-radius: 0.16rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
}

.text-red {
  .theme-mixins(color, #FA3B32, #CF3930);
}

.text-green {
  color: #00B650;
}

.text-black {
  .theme-mixins(color, #323232, #D2D2D3);
}
</style>
